import React from "react";
import { TextInput } from "../../../../FlowConfigurationInputs/TextInput/TextInput";
import FormControl from "@material-ui/core/FormControl";
import { MenuItem, Select } from "@material-ui/core";

function Parameters({ data, action, variables, setOpenVariable, automId }) {

    function itemRender() {
        return data.map((item) => {
            if (item === "model_id") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue="123125436-231123-13asd-134asd"
                            isRequired={false}
                        />
                        <small>
                            Destination id for this model; auto-generated if not specified.
                        </small>
                    </div>
                );
            } else if (item === "training_frame") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">keyFrame_1</MenuItem>
                                <MenuItem value="removeMatchReows">keyFrame2</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Id of the training data frame.</small>
                    </div>
                );
            } else if (item === "user_y") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">keyFrame_1</MenuItem>
                                <MenuItem value="removeMatchReows">keyFrame2</MenuItem>
                            </Select>
                        </FormControl>
                        <small>User-specified initial Y</small>
                    </div>
                );
            } else if (item === "user_x") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">keyFrame_1</MenuItem>
                                <MenuItem value="removeMatchReows">keyFrame2</MenuItem>
                            </Select>
                        </FormControl>
                        <small>User-specified initial X</small>
                    </div>
                );
            } else if (item === "pre_trained") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">keyFrame_1</MenuItem>
                                <MenuItem value="removeMatchReows">keyFrame2</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Id of a data frame that contains a pre-trained (external) word2vec model	</small>
                    </div>
                );
            } else if (item === "word_model") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">SkipGram</MenuItem>
                                <MenuItem value="onlyMatchRows">CBOW</MenuItem>
                            </Select>
                        </FormControl>
                        <small>The word model to use (SkipGram or CBOW)	</small>
                    </div>
                );
            } else if (item === "norm_model") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">HSM</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Use Hierarchical Softmax	</small>
                    </div>
                );
            } else if (item === "blending_frame") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">keyFrame_1</MenuItem>
                                <MenuItem value="removeMatchReows">keyFrame2</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                );
            } else if (item === "transform") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">NONE</MenuItem>
                                <MenuItem value="removeMatchReows">STANDARDIZE</MenuItem>
                                <MenuItem value="removeMatchReows">NORMALIZE</MenuItem>
                                <MenuItem value="removeMatchReows">DEMEAN</MenuItem>
                                <MenuItem value="removeMatchReows">DESCALE</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Transformation of training data	</small>
                    </div>
                );
            } else if (item === " metalearner_transform") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">NONE</MenuItem>
                                <MenuItem value="removeMatchReows">Logit</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Transformation used for the level one frame.	</small>
                    </div>
                );
            } else if (item === "loss") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">Quadratic</MenuItem>
                                <MenuItem value="removeMatchReows">Absolute</MenuItem>
                                <MenuItem value="removeMatchReows">Huber</MenuItem>
                                <MenuItem value="removeMatchReows">Hinge</MenuItem>
                                <MenuItem value="removeMatchReows">Logistic</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Numeric loss function </small>
                    </div>
                );
            } else if (item === "algorithm") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">AUTO</MenuItem>
                                <MenuItem value="removeMatchReows">DRF</MenuItem>
                                <MenuItem value="removeMatchReows">GBM</MenuItem>
                            </Select>
                        </FormControl>
                        <small>The algorithm to use to generate rules.	</small>
                    </div>
                );
            } else if (item === "metalearner_algorithm") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">drf</MenuItem>
                                <MenuItem value="removeMatchReows">deeplearning</MenuItem>
                                <MenuItem value="removeMatchReows">gbm</MenuItem>
                                <MenuItem value="removeMatchReows">glm</MenuItem>
                                <MenuItem value="removeMatchReows">naivebayes</MenuItem>
                                <MenuItem value="removeMatchReows">glm</MenuItem>
                                <MenuItem value="removeMatchReows">xgboost</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Type of algorithm to use as the metalearner. Options include 'AUTO' (GLM with non negative weights; if validation_frame is present, a lambda search is performed), 'deeplearning' (Deep Learning with default parameters), 'drf' (Random Forest with default parameters), 'gbm' (GBM with default parameters), 'glm' (GLM with default parameters), 'naivebayes' (NaiveBayes with default parameters), or 'xgboost' (if available, XGBoost with default parameters).	</small>
                    </div>
                );
            } else if (item === "model_type") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">RULES</MenuItem>
                                <MenuItem value="removeMatchReows">RULES_AND_LINEAR</MenuItem>
                                <MenuItem value="removeMatchReows">LINEAR</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Specifies type of base learners in the ensemble.	</small>
                    </div>
                );
            } else if (item === "multi_loss") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">Categorical</MenuItem>
                                <MenuItem value="removeMatchReows">Ordinal</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Categorical loss function </small>
                    </div>
                );
            } else if (item === "regularization_x") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">None</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Regularization function for X matrix </small>
                    </div>
                );
            } else if (item === "regularization_y") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">None</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Regularization function for Y matrix </small>
                    </div>
                );
            } else if (item === "validation_frame") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">keyFrame_1</MenuItem>
                                <MenuItem value="removeMatchReows">keyFrame2</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Id of the validation data frame. </small>
                    </div>
                );
            } else if (item === "plug_values") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">keyFrame_1</MenuItem>
                                <MenuItem value="removeMatchReows">keyFrame2</MenuItem>
                            </Select>
                        </FormControl>
                        <small>
                            Plug Values (a single row frame containing values that will be
                            used to impute missing values of the training/validation frame,
                            use with conjunction missing_values_handling = PlugValues){" "}
                        </small>
                    </div>
                );
            } else if (item === "solver") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">AUTO</MenuItem>
                                <MenuItem value="removeMatchReows">IRLSM</MenuItem>
                                <MenuItem value="removeMatchReows">L_BFGS</MenuItem>
                                <MenuItem value="removeMatchReows">
                                    COORDINATE_DESCENT_NAIVE
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <small>
                            AUTO will set the solver based on given data and the other
                            parameters. IRLSM is fast on on problems with small number of
                            predictors and for lambda-search with L1 penalty, L_BFGS scales
                            better for datasets with many columns.{" "}
                        </small>
                    </div>
                );
            } else if (item === "family") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">AUTO</MenuItem>
                                <MenuItem value="removeMatchReows">gaussian</MenuItem>
                                <MenuItem value="removeMatchReows">binomial</MenuItem>
                                <MenuItem value="removeMatchReows">fractionalbinomial</MenuItem>
                                <MenuItem value="removeMatchReows">quasibinomial</MenuItem>
                                <MenuItem value="removeMatchReows">ordinal</MenuItem>
                                <MenuItem value="removeMatchReows">poisson</MenuItem>
                                <MenuItem value="removeMatchReows">gamma</MenuItem>
                            </Select>
                        </FormControl>
                        <small>
                            Family. Use binomial for classification with logistic regression,
                            others are for regression problems.{" "}
                        </small>
                    </div>
                );
            } else if (item === "beta_constraints") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">keyFrame_1</MenuItem>
                                <MenuItem value="removeMatchReows">keyFrame2</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                );
            } else if (item === "response_column") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows"></MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                );
            } else if (item === "ignore_const_cols") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                        <small>Ignore constant columns.</small>
                    </div>
                );
            } else if (item === "variable_importances") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                        <small>
                            Compute variable importances for input features (Gedeon method) -
                            can be slow for large networks.{" "}
                        </small>
                    </div>
                );
            } else if (item === "start_column") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows"></MenuItem>
                            </Select>
                        </FormControl>
                        <small>Start Time Column</small>
                    </div>
                );
            } else if (item === "svd_method") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">Randomized</MenuItem>
                                <MenuItem value="onlyMatchRows">GramSVD</MenuItem>
                                <MenuItem value="onlyMatchRows">Power</MenuItem>
                                <MenuItem value="onlyMatchRows">Randomized</MenuItem>
                            </Select>
                        </FormControl>
                        <small>
                            Method for computing SVD during initialization (Caution:
                            Randomized is currently experimental and unstable){" "}
                        </small>
                    </div>
                );
            } else if (item === "stop_column") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows"></MenuItem>
                            </Select>
                        </FormControl>
                        <small>Stop Time Column. </small>
                    </div>
                );
            } else if (item === "ties") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">efron</MenuItem>
                                <MenuItem value="onlyMatchRows">breslow</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Method for Handling Ties. </small>
                    </div>
                );
            } else if (item === "init") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Coefficient starting value.</small>
                    </div>
                );
            } else if (item === "gamma_x") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Regularization weight on X matrix </small>
                    </div>
                );
            } else if (item === "gamma_y") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Regularization weight on Y matrix </small>
                    </div>
                );
            } else if (item === "expand_user_y") {
                return (
                    <div className="form-element">
                        <input type="checkbox" />
                        <small>
                            Expand categorical columns in user-specified initial Y{" "}
                        </small>
                    </div>
                );
            } else if (item === "max_updates") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>
                            Maximum number of updates, defaults to 2*max_iterations{" "}
                        </small>
                    </div>
                );
            } else if (item === "init_step_size") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Initial step size </small>
                    </div>
                );
            } else if (item === "min_step_size") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Minimum step size </small>
                    </div>
                );
            } else if (item === "ire_min") {
                return (
                    <div className="form-element">
                        lre_min
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={9}
                        />
                        <small>Minimum log-relative error. </small>
                    </div>
                );
            } else if (item === "max_iterations") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={9}
                        />
                        <small>Maximum number of iterations. </small>
                    </div>
                );
            } else if (item === "hidden") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={9}
                        />
                        <small>Hidden layer sizes (e.g. [100, 100]). </small>
                    </div>
                );
            } else if (item === "epochs") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={9}
                        />
                        <small>
                            How many times the dataset should be iterated (streamed), can be
                            fractional.{" "}
                        </small>
                    </div>
                );
            } else if (item === "nfolds") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={9}
                        />
                        <small>
                            Number of folds for K-fold cross-validation (0 to disable or `{'>'}`=
                            2).{" "}
                        </small>
                    </div>
                );
            } else if (item === "ntrees") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={50}
                        />
                        <small>Number of trees. </small>
                    </div>
                );
            } else if (item === "loss_by_col_idx") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Loss function by column index (override) </small>
                    </div>
                );
            } else if (item === "max_depth") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Maximum tree depth (0 for unlimited). </small>
                    </div>
                );
            } else if (item === "min_rows") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Fewest allowed (weighted) observations in a leaf. </small>
                    </div>
                );
            } else if (item === "ignored_columns") {
                return (
                    <div className="form-element">
                        ignored_columns
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={9}
                        />
                        <small>Names of columns to ignore for training. </small>
                    </div>
                );
            } else if (item === "activation") {
                return (
                    <div className="form-element" style={{ width: "90%" }}>
                        activation
                        <FormControl variant="outlined" fullWidth>
                            <Select>
                                <MenuItem value="onlyMatchRows">Rectifier</MenuItem>
                                <MenuItem value="removeMatchReows">
                                    RectifierWithDropout
                                </MenuItem>
                                <MenuItem value="removeMatchReows">Tanh</MenuItem>
                                <MenuItem value="removeMatchReows">TanhWithDropout</MenuItem>
                                <MenuItem value="removeMatchReows">Maxout</MenuItem>
                                <MenuItem value="removeMatchReows">MaxoutWithDropout</MenuItem>
                            </Select>
                        </FormControl>
                        <small>Activation function. </small>
                    </div>
                );
            } else if (item === "nbins") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={20}
                        />
                        <small>
                            For numerical columns (real/int), build a histogram of (at least)
                            this many bins, then split at the best point{" "}
                        </small>
                    </div>
                );
            } else if (item === "seed") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>
                            Seed for pseudo random number generator (if applicable){" "}
                        </small>
                    </div>
                );
            } else if (item === "mtries") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={-1}
                        />
                        <small>
                            Number of variables randomly sampled as candidates at each split.
                            If set to -1, defaults to sqrt p for classification and p/3 for
                            regression (where p is the # of predictors{" "}
                        </small>
                    </div>
                );
            } else if (item === "sample_rate") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0.0}
                        />
                        <small>Row sample rate per tree (from 0.0 to 1.0) </small>
                    </div>
                );
            } else if (item === "learn_rate") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Learning rate (from 0.0 to 1.0) </small>
                    </div>
                );
            } else if (item === "col_sample_rate") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Column sample rate (from 0.0 to 1.0) </small>
                    </div>
                );
            } else if (item === "representation_name") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Frame key to save resulting X </small>
                    </div>
                );
            } else if (item === "loading_name") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <div>
                            [Deprecated] Use representation_name instead. Frame key to save
                            resulting X.{" "}
                        </div>
                    </div>
                );
            } else if (item === "k*") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Rank of matrix approximation </small>
                    </div>
                );
            } else if (item === "rand_family") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue="gaussian"
                        />
                        <small>
                            Random Component Family array. One for each random component. Only
                            support gaussian for now.{" "}
                        </small>
                    </div>
                );
            } else if (item === "random_columns") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                    </div>
                );
            } else if (item === "keep_original_categorical_columns") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                        <small>If true, the original non-encoded categorical features will remain in the result frame.	</small>
                    </div>
                );
            } else if (item === "lambda") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                    </div>
                );
            } else if (item === "lambda_search") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                    </div>
                );
            } else if (item === "stabdardize") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                    </div>
                );
            } else if (item === "non_negative") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                    </div>
                );
            } else if (item === "startval") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                    </div>
                );
            } else if (item === "calc_like") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                    </div>
                );
            } else if (item === "HGLM") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                    </div>
                );
            } else if (item === "cold_start") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                    </div>
                );
            } else if (item === "obj_reg") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                    </div>
                );
            } else if (item === "period") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>
                            Length of period (only used with periodic loss function){" "}
                        </small>
                    </div>
                );
            } else if (item === "contamination") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Contamination ratio - the proportion of anomalies in the input dataset. If undefined (-1) the predict function will not mark observations as anomalies and only anomaly score will be returned. Defaults to -1 (undefined).	</small>
                    </div>
                );
            } else if (item === "sample_size") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Number of randomly sampled observations used to train each Isolation Forest tree. Only one of parameters sample_size and sample_rate should be defined. If sample_rate is defined, sample_size will be ignored.	</small>
                    </div>
                );
            } else if (item === "estimate_k") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Whether to estimate the number of clusters   iteratively and deterministically.	</small>
                    </div>
                );
            } else if (item === "k") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>The max. number of clusters. If estimate_k is disabled, the model will find k centroids, otherwise it will find up to k centroids.	</small>
                    </div>
                );
            } else if (item === "metalearner_params") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                    </div>
                );
            } else if (item === "metalearner_nfolds") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Number of folds for K-fold cross-validation of the metalearner algorithm (0 to disable or `{'>'}`= 2).	</small>
                    </div>
                );
            } else if (item === "standardize") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                        <small>
                            Standardize numeric columns to have zero mean and unit variance
                        </small>
                    </div>
                );
            } else if (item === "laplace") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                    </div>
                );
            } else if (item === "min_sdev") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                    </div>
                );
            } else if (item === "eps_sdev") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Cutoff below which standard deviation is replaced with min_sdev	</small>
                    </div>
                );
            } else if (item === "min_prob") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Min. probability to use for observations with not enough data	</small>
                    </div>
                );
            } else if (item === "eps_prob") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Cutoff below which probability is replaced with min_prob	</small>
                    </div>
                );
            } else if (item === "compute_metrics") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                        <small>Compute metrics on training data	</small>
                    </div>
                );
            } else if (item === "impute_missing") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />

                    </div>
                );
            }
            else if (item === "recover_svd") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                        <small>Recover singular values and eigenvectors of XY</small>
                    </div>
                );
            }
            else if (item === "use_all_factor_levels") {
                return (
                    <div className="form-element">
                        {item}
                        <input type="checkbox" />
                    </div>
                );
            } else if (item === "min_rule_length") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Minimum length of rules. Defaults to 3.	</small>
                    </div>
                );
            } else if (item === "max_rule_length") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Maximum length of rules. Defaults to 3.	</small>
                    </div>
                );
            } else if (item === "max_num_rules") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>The maximum number of rules to return. defaults to -1 which means the number of rules is selected by diminishing returns in model deviance.	</small>
                    </div>
                );
            } else if (item === "rule_generation_ntrees") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={50}
                        />
                        <small>specifies the number of trees to build in the tree model. Defaults to 50.	</small>
                    </div>
                );
            } else if (item === "min_word_freq") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>This will discard words that appear less than  int times	</small>
                    </div>
                );
            } else if (item === "vec_size") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                    </div>
                );
            } else if (item === "window_size") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Set max skip length between words	</small>
                    </div>
                );
            } else if (item === "sent_sample_rate") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                    </div>
                );
            } else if (item === "init_learning_rate") {
                return (
                    <div className="form-element">
                        {item}
                        <TextInput
                            action={action}
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            inputName={item}
                            defaultValue={0}
                        />
                        <small>Set the starting learning rate	</small>
                    </div>
                );
            }
        });
    }

    return <div>{itemRender()}</div>;
}

export default Parameters;
